interface InfoBadgeProps {
  title: string;
}

export function InfoBadge({ title }: InfoBadgeProps) {
  return (
    <span
      title={title}
      className="inline-grid h-[15px] w-[15px] shrink-0 place-items-center rounded-full border-[1.3px] border-subtle font-sans text-[10px] font-semibold normal-case tracking-normal text-subtle"
    >
      i
    </span>
  );
}
